export default {
  data () {
    return {
      columns: [
        {
          label: 'Регион',
          field: 'region',
          name: 'region',
          align: 'left',
        },
        {
          label: 'Версия БД',
          field: 'database_id',
          name: 'database_id',
          align: 'left',
        },
        {
          label: 'Версия бекенда',
          field: 'backend_name',
          name: 'backend_name',
          align: 'left',
        },
        {
          label: 'Дата создания',
          field: 'created_at',
          name: 'created_at',
          align: 'left',
        },
        {
          label: 'Дата обновления',
          name: 'updated_at',
          field: 'updated_at',
          align: 'left',
        },
        {
          label: 'Ред.',
          name: 'edit',
          field: 'id',
          align: 'right',
        },
      ],
    }
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/McpProjectConfigs/mixins/columns.js